import { cx } from "cva";
import { type ButtonHTMLAttributes } from "react";

import { SubtleButtonProps, variants } from ".";

export const SubtleButton = ({
  className,
  children,
  type = "button",
  align,
  radius,
  color,
  width,
  ...props
}: Readonly<ButtonHTMLAttributes<HTMLButtonElement> & SubtleButtonProps>) => (
  <button type={type} className={cx(className, variants({ align, radius, width }))} {...props}>
    {children}
  </button>
);
